import "./Ui.css";

export const Input = ({ label, error, ...rest }) => (
  <label style={{ display: "block" }}>
    {label && <span className="muted small" style={{ display: "block", marginBottom: 6 }}>{label}</span>}
    <input className="input" aria-invalid={!!error} {...rest} />
    {error && <span role="alert" className="small" style={{ color: "var(--bad)" }}>{error}</span>}
  </label>
);

export const Alert = ({ tone = "bad", children }) =>
  children ? <p role="alert" className={`alert ${tone}`}>{children}</p> : null;

const TONES = ["success", "pending", "partial", "review", "refunded"];
export const Status = ({ value }) => (
  <span className={`badge ${TONES.includes(value) ? value : "default"}`}>{value}</span>
);
